export default "__VITE_ASSET__DeI35hFL__"